export default "/images/cat-logo-1.png?3d1ab3b27b314e3886d4267ac221079f";